module.exports = __webpack_public_path__ + "static/media/hospitalThumbnail2.48057e7b.jpg";